import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/global.css";

/** Funde el splash de index.html cuando React ya pintó su primer frame. */
function SplashRelease() {
  useEffect(() => {
    const splash = document.getElementById("mx-splash");
    if (!splash) return undefined;
    splash.classList.add("mx-splash--out");
    const timer = window.setTimeout(() => splash.remove(), 260);
    return () => window.clearTimeout(timer);
  }, []);
  return null;
}

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root in index.html");

createRoot(root).render(
  <StrictMode>
    <SplashRelease />
    <App />
  </StrictMode>,
);
